import { type Common } from './common.js';
import { type FindAllOptions, type PatientFeedItem } from './models/feedItems.js';

export class API {
  common: Common;
  baseEndpoint = 'feeds';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(feedId: string, query: FindAllOptions = {}): Promise<PatientFeedItem[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${feedId}/items`, query);
    return await this.common.getJSON(url);
  }

  async findAllCounts(
    feedId: string,
    query: FindAllOptions = {}
  ): Promise<{ success: boolean; counts: number }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${feedId}/items/counts`, query);
    return await this.common.getJSON(url);
  }
}
